<script setup lang="ts">
import EventTicketForm from "@/components/events/AddEditDialog/EventTicketForm.vue";

const ticketsConfig = defineModel<any[]>({ required: true });

const props = defineProps<{
  eventName?: string;
  eventDescription?: string;
}>();

const ticketFormRefs = ref<any[]>([]);

const createDefaultTicket = () => ({
  name: props.eventName || "",
  sellPrice: 0,
  sortOrder: 0,
  eventBarValue: 0,
  eventTicketLimit: 0,
  description: props.eventDescription || "",
  maxDiscount: 0,
  canBuyInWebshop: true,
  canBuyInKiosk: false,
  btnTextColor: "",
  btnBackColor: "",
  productImage: null,
});

const handleRemove = (index: number) => {
  ticketsConfig.value = ticketsConfig.value?.filter((_: any, i: number) => i !== index);
};

const handleAdd = async () => {
  const results = await Promise.all(ticketFormRefs.value.map(ref => ref?.validate()));
  if (results.some(r => r?.valid === false)) return;
  ticketsConfig.value = [...(ticketsConfig.value ?? []), createDefaultTicket()];
};

defineExpose({
  validate: async () => {
    const results = await Promise.all(ticketFormRefs.value.map(ref => ref?.validate()));
    return { valid: results.every(r => r?.valid !== false) };
  },
});
</script>

<template>
  <VWindowItem>
    <div class="mb-6">Ticket Configuration</div>
    <div>
      <EventTicketForm
        v-for="(_, index) in ticketsConfig"
        :key="index"
        ref="ticketFormRefs"
        v-model="ticketsConfig[index]"
        @remove="handleRemove(index)"
      />
    </div>
    <div class="mt-3">
      <VBtn color="primary" @click="handleAdd">Add</VBtn>
    </div>
  </VWindowItem>
</template>
